import { resizeThumbnail as _resizeThumbnail } from '@wix/communities-blog-universal/dist/src/utils/media/thumbnail';
import { getConfig } from './config';

export const resizeThumbnail = (pathname, width, height) =>
  _resizeThumbnail(getConfig().imageHost)(pathname, width, height);
